import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTemplateDetail = createSelector(
  [(store: RootState) => store.templateDetail.template],
  (template) => template
);
